<div class="border-card border-0 px-4 py-1 scroll-container">
  <div class="row mt-3 g-3 flex-wrap">
    <div class="col-12 col-sm-6 col-md-4 mb-3 d-flex">
      <div
        class="w-100 h-100"
        :class="{ 'active-tab': selected_status === 'Compliant' }"
        @click="filter_by_status('Compliant')"
      >
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center justify-content-between flex-wrap py-3 px-3">
            <div class="d-flex align-items-center gap-3 w-100">
              <div class="bg-white circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
                <i class="fa-solid bi-shield-check fa-lg text-primary"></i>
              </div>
              <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
                <p class="mb-1 text-xs text-white">Compliant</p>
                <p class="m-0 fw-bold text-white">{{ compliant_count }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-4 mb-3 d-flex">
      <div
        class="w-100 h-100"
        :class="{ 'active-tab': selected_status === 'Non-Compliant' }"
        @click="filter_by_status('Non-Compliant')"
      >
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center justify-content-between flex-wrap py-3 px-3">
            <div class="d-flex align-items-center gap-3 w-100">
              <div class="bg-white circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
                <i class="bi-x-octagon-fill fa-lg text-primary"></i>
              </div>
              <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
                <p class="mb-1 text-xs text-white">Non-Compliant</p>
                <p class="m-0 fw-bold text-white">{{ non_compliant_count }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-4 mb-3 d-flex">
      <div
        class="w-100 h-100"
        :class="{ 'active-tab': selected_status === 'At Risk' }"
        @click="filter_by_status('At Risk')"
      >
        <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
          <div class="card-body d-flex align-items-center justify-content-between flex-wrap py-3 px-3">
            <div class="d-flex align-items-center gap-3 w-100">
              <div class="bg-white circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
                <i class="bi-exclamation-triangle-fill fa-lg text-primary"></i>
              </div>
              <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
                <p class="mb-1 text-xs text-white lh-sm">
                  Risk of being non-compliant
                </p>
                <p class="m-0 fw-bold text-white">{{ at_risk_count }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card bg-white rounded-lg mt-3 border-0 p-3">
    <div class="mt-3 px-3">
      <p class="mb-3 fs-6 mt-2">
        {{ table_title }}
      </p>
    </div>

    <div class="card shadow-sm border table-border-color rounded-lg p-3 table-responsive">
  <div class="p-3">
    <div class="table-responsive">
      <table id="compliance_table" class="table table-hover">
        <thead class="custom-header">
          <tr>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">ID</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Name</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Created</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entity, index) in entity_types" :key="index">
            <td class="text-xxs text-start">{{ entity.id }}</td>
            <td class="text-xxs text-start">{{ entity.entity_type_name }}</td>
            <td class="text-xxs text-start">{{ entity.entity_type_description }}</td>
            <td class="text-xxs text-start">{{ entity.date_created }}</td>
            <td class="text-xxs text-start">
              <span class="status-badge" :class="selected_status.toLowerCase().replace(' ', '-')">
                {{ selected_status }}
              </span>
            </td>
            <td>
              <button
                class="btn btn btn-secondary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
                @click="go_to_pending_compliance_checks({ entity })"
              >
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
  </div>
</div>

<footer>
  <AICampusFooter/>
</footer>
